import {
  orderHistoryService,
  productServiceWithInHouseData,
  paginatedOrderHistoryService,
  orderService,
  storeService,
  conversationServiceV2,
  orderServiceV2,
} from 'config/api';
import actionTypes from './actionTypes';

/**
 * CLient Order History
 */
export const getPaginatedClientOrdersV2 =
  (requestBody, apiVersion = 'v2') =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.GET_CLIENT_ORDER_HISTORY_LOADING,
    });

    try {
      const url = `/${apiVersion}/retrieve/customerOrders`;
      const { data } = await paginatedOrderHistoryService.post(url, requestBody);

      dispatch({
        type: actionTypes.GET_CLIENT_ORDER_HISTORY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: actionTypes.GET_CLIENT_ORDER_HISTORY_ERROR,
        payload: error,
      });
    }
  };
/**
 *
 * @param {{}} payload
 * @returns {(function(*): Promise<void>)|*}
 */
export const sendGiftReceipt = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.SEND_GIFT_RECEIPT_LOADING });
  try {
    const { data } = await conversationServiceV2.post('send/giftReceipt', payload);
    dispatch({ type: actionTypes.SEND_GIFT_RECEIPT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: actionTypes.SEND_GIFT_RECEIPT_ERROR,
      payload: error,
    });
  }
};

export const voidOrder = (orderId, isVertexOEnabled) => async (dispatch) => {
  dispatch({
    type: actionTypes.SUBMIT_VOID_ORDER_LOADING,
  });

  let formattedNum = orderId.split(':')[0];
  if (formattedNum.length === 1) {
    formattedNum = `0${formattedNum}`;
  }

  const service = isVertexOEnabled ? orderServiceV2 : orderService;
  try {
    const voidOrderPromise = service.post('pos/void/', { orderId });
    const getStoreInfoPromise = storeService.get(`/${formattedNum}`);

    const responses = await Promise.all([voidOrderPromise, getStoreInfoPromise]);

    dispatch({
      type: actionTypes.SUBMIT_VOID_ORDER_SUCCESS,
      payload: responses,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.SUBMIT_VOID_ORDER_ERROR,
      payload: error,
    });
  }
};

export const setClientOrders = (orders = []) => {
  return {
    type: actionTypes.GET_CLIENT_ORDER_HISTORY_SUCCESS,
    payload: orders,
  };
};

export const setAssociateOrders = (orders = []) => {
  return {
    type: actionTypes.GET_ASSOCIATE_ORDER_HISTORY_SUCCESS,
    payload: orders,
  };
};

export const setOrderDetails = (order = {}) => {
  return {
    type: actionTypes.GET_ORDER_BY_ID_SUCCESS,
    payload: order,
  };
};

export const getOrderbyId = (orderId) => async (dispatch) => {
  dispatch({
    type: actionTypes.GET_ORDER_BY_ID_LOADING,
  });

  try {
    const url = `orders/${orderId}`;
    const response = await orderHistoryService.get(url);

    dispatch({
      type: actionTypes.GET_ORDER_BY_ID_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.GET_ORDER_BY_ID_ERROR,
      payload: error,
    });
  }
};

export const getProductsForOrder = () => async (dispatch, getState) => {
  dispatch({
    type: actionTypes.GET_PRODUCTS_FOR_ORDER_LOADING,
  });

  const order = getState().clientsModule?.orderDetails?.data;
  const clientId = order?.accountId;
  const productsIds = order?.orderDetails
    ?.map(({ items = [] }) => items.map((item) => item.pimSkuId || item.cmosSkuId))
    .join(',');
  try {
    const response = await productServiceWithInHouseData.get(`?product_id=${productsIds}`, { clientId });

    dispatch({
      type: actionTypes.GET_PRODUCTS_FOR_ORDER_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.GET_PRODUCTS_FOR_ORDER_ERROR,
      payload: error,
    });
  }
};

export const resetClientOrders = () => ({
  type: actionTypes.RESET_CLIENT_ORDER_HISTORY,
});

export const resetClientOrdersKeepFilters = () => ({
  type: actionTypes.RESET_CLIENT_ORDER_HISTORY_KEEP_FILTERS,
});

export const restoreClientOrders = (ordersState) => ({
  type: actionTypes.RESTORE_CLIENT_ORDER_HISTORY,
  payload: ordersState,
});

export const restoreAssociateOrders = (ordersState) => ({
  type: actionTypes.RESTORE_ASSOCIATE_ORDER_HISTORY,
  payload: ordersState,
});

/**
 * Resend Receipt
 */
export const resendReceipt = (receiptEmail, orderId) => async (dispatch) => {
  dispatch({
    type: actionTypes.RESEND_RECEIPT_LOADING,
  });

  try {
    const { data: payload } = await new Promise((resolve) => {
      setTimeout(() => resolve({ data: { receiptEmail, orderId } }), 2000);
    });
    dispatch({ type: actionTypes.RESEND_RECEIPT_SUCCESS, payload });
  } catch (error) {
    dispatch({
      type: actionTypes.RESEND_RECEIPT_ERROR,
      payload: error,
    });
  }
};

/**
 * Associate Order History
 */
export const getPaginatedAssociateOrdersV2 =
  (requestBody, version = 'v2') =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.GET_ASSOCIATE_ORDER_HISTORY_LOADING,
    });

    try {
      const url = `${version}/retrieve/associateOrders`;
      const { data } = await paginatedOrderHistoryService.post(url, requestBody);
      dispatch({
        type: actionTypes.GET_ASSOCIATE_ORDER_HISTORY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: actionTypes.GET_ASSOCIATE_ORDER_HISTORY_ERROR,
        payload: error,
      });
    }
  };

export const resetAssociateOrders = () => ({
  type: actionTypes.RESET_ASSOCIATE_ORDER_HISTORY,
});

export const resetAssociateOrdersKeepFilters = () => ({
  type: actionTypes.RESET_ASSOCIATE_ORDER_HISTORY_KEEP_FILTERS,
});

export const resetOrderDetails = () => ({
  type: actionTypes.RESET_ORDER_DETAILS,
});

export const getOrderDetails =
  ({ orderId, channelCode, version = 'v2' }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.GET_ORDER_BY_ID_LOADING,
    });

    try {
      const url = `/${version}/fetchOrderDetails/order/${orderId}/channel/${channelCode}`;
      const { data } = await paginatedOrderHistoryService.get(url);

      dispatch({
        type: actionTypes.GET_ORDER_BY_ID_SUCCESS,
        payload: { ...data, channel: channelCode },
      });
    } catch (error) {
      dispatch({
        type: actionTypes.GET_ORDER_BY_ID_ERROR,
        payload: error,
      });
    }
  };

export const addCachedOrderData = (cachedOrderData) => async (dispatch) => {
  dispatch({
    type: actionTypes.ADD_CACHED_ORDER_DETAILS,
    payload: cachedOrderData,
  });
};

export const getFailedOrderDetails = (orderId) => async (dispatch) => {
  dispatch({
    type: actionTypes.GET_ORDER_BY_ID_LOADING,
  });

  try {
    const url = `/v2/fetchOrderFailureDetails/order/${orderId}`;
    const { data } = await paginatedOrderHistoryService.get(url);
    dispatch({
      type: actionTypes.GET_ORDER_BY_ID_SUCCESS,
      payload: { ...data },
    });
  } catch (error) {
    dispatch({
      type: actionTypes.GET_ORDER_BY_ID_ERROR,
      payload: error,
    });
  }
};

export const getStatusOfSends = (payload) => {
  return () =>
    new Promise((resolve, reject) => {
      const url = '/v1/fetchStatusOfSends';
      paginatedOrderHistoryService
        .post(url, payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          const message = error;
          reject(message);
        });
    });
};
